import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled, { CSSProp } from 'styled-components';

export const ContentCardStyled = styled.div<{ $minHeight?: string }>`
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 4rem 10rem 8rem;
  min-height: ${({ $minHeight }): CSSProp => $minHeight || '38rem'};

  ${breakpointsMQ4.lg.down} {
    padding: 4rem 4rem 8rem;
  }

  ${breakpointsMQ4.sm.down} {
    padding: 2rem 2rem 4rem;
  }
`;
